import { RequestContextType } from "@utils/api-config/RequestContext";
import { getDefaultRequestContext } from "@utils/api-config/getDefaultRequestContext";
import { getOnlineUserRequestContext } from "@utils/api-config/getOnlineUserRequestContext";
import { getShopUserRequestContext } from "@utils/api-config/getShopUserRequestContext";
import { getWalletRequestContext } from "@utils/api-config/getWalletRequestContext";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";

export function getApiRequestContext(
	options: ContextOptions = {}
): ApiRequestContextData {
	const contextType = options.context || RequestContextType.Default;
	let context;
	switch (contextType) {
		case RequestContextType.Shop:
			context = getShopUserRequestContext();
			break;
		case RequestContextType.Online:
			context = getOnlineUserRequestContext();
			break;

		case RequestContextType.Wallet:
			context = getWalletRequestContext(options.walletId);
			break;

		case RequestContextType.Default:
		default:
			context = getDefaultRequestContext();
	}

	if (!context) {
		return getDefaultRequestContext();
	}
	return context;
}
